import axios from 'axios';

export interface CheckPaymentStatusResponse {
  status: {
    state: string;
    errorMessageToShow: string;
  };
  bookingModel: {
    hotel: any;
    roomClass: any;
    orderId: number;
    paxes: any[];
    statusGoToXX: boolean;
    statusIsOK: boolean;
    couponAmount: number;
  };
  errorMessage: any;
  hasErrors: boolean;
  orderHasBeenPaid: boolean;
}

export const checkPaymentStatus = async (
  transactionId?: string,
  orderId?: number
): Promise<CheckPaymentStatusResponse | undefined> => {
  try {
    const url = 'Hotels/CheckPaymentStatus';

    return (await axios.post(url, { transactionId, orderId })).data;
  } catch (err) {
    return undefined;
  }
};

export const checkMultiPaymentStatus = async (
  transactionId: string,
  orderId: number
): Promise<CheckPaymentStatusResponse | undefined> => {
  try {
    const url = 'Utils/CheckMultiPaymentStatus';

    return (await axios.post(url, { transactionId, orderId })).data;
  } catch (err) {
    return undefined;
  }
};

export const refreshPayment = async (
  transactionId: string,
  orderId: number
): Promise<any | undefined> => {
  try {
    const url = 'Utils/RefreshPayment';

    return (await axios.post(url, { transactionId, orderId })).data;
  } catch (err) {
    return undefined;
  }
};

export const newPayment = async (orderId: number): Promise<any | undefined> => {
  try {
    const url = 'Utils/NewPayment';

    return (await axios.post(url, { orderId })).data;
  } catch (err) {
    return undefined;
  }
};

export const fakeApproveCreditGuard = async (
  orderId: number,
  transactionId: string,
  fail: boolean
): Promise<any | undefined> => {
  try {
    const url = 'Utils/FakeApproveCreditGuard';

    return (await axios.post(url, { orderId, transactionId, fail })).data;
  } catch (err) {
    return undefined;
  }
};

export const fakeApproveFinalStep = async (
  orderId: number,
  fail: boolean
): Promise<any | undefined> => {
  try {
    const url = 'Hotels/FakeApproveFinalStep';

    return (await axios.post(url, { orderId, fail })).data;
  } catch (err) {
    return undefined;
  }
};
export const convertCurrencytoShekels = async (sourcePrice: number, packageCurrency: string) => {
  try {
    const url = 'Utils/ConvertCurrencytoShekels';
    return (await axios.post(url, { sourcePrice, packageCurrency })).data;
  } catch (err) {
    return undefined;
  }
};

export const createNewPaymentBlock = async (sourcePrice: number, language: string = 'He') => {
  try {
    const url = 'Utils/CreateNewPaymentBlock';
    return (await axios.post(url, { sourcePrice: Math.round(sourcePrice), language })).data
      .credit2000PaymentInfo;
  } catch (err) {
    return undefined;
  }
};
